export const ACCESS_TOKEN_PARAM = 'access_token';
export const REFRESH_TOKEN_PARAM = 'refresh_token';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const PROFILE_NAME_KEY = 'profileName';
export const NUMBER_KEY = 'loginNumber';
export const IS_ADMIN = 'isAdmin';
export const POLL_STATUS_INTERVAL_SEC = 10;
export const POLL_STATUS_TIMEOUT_SEC = 300;


